import React from 'react';
import UserRow from './UserRow';
import FilterableTable from '../filters/FilterableTable';
import { findAllUsersPageble } from '../../actions/user';

const SUPER_ADMIN_ROLE = 'SUPER_ADMIN';

const UserTable = ({
  deleteUser,
  updateUser,
  deactivateUser,
  activateUser,
  dispatch,
  clearValidationErrors,
  userReducer,
  userRoleReducer,
  securityReducer,
}) => {
  const { userList, totalElements } = userReducer;
  const {loggedUser} = securityReducer;

  const isSuperAdmin = loggedUser?.role?.roleName === SUPER_ADMIN_ROLE;

  const userListRow = userList.map((user) => (
    <UserRow
      key={user.id}
      user={user}
      deleteUser={deleteUser}
      updateUser={updateUser}
      deactivateUser={deactivateUser}
      activateUser={activateUser}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      userReducer={userReducer}
      userRoleReducer={userRoleReducer}
      loggedUser={loggedUser}
    />
  ));

  const columns = [
    {
      id: 'Ime',
      name: 'Ime',
      filter: { field: 'firstName', value: '', type: 'LIKE' },
    },
    {
      id: 'Prezime',
      name: 'Prezime',
      filter: { field: 'lastName', value: '', type: 'LIKE' },
    },
    {
      id: 'Korisničko ime',
      name: 'Korisničko ime',
      filter: { field: 'username', value: '', type: 'LIKE' },
    },
    {
      id: 'E-mail',
      name: 'E-mail',
      filter: { field: 'email', value: '', type: 'LIKE' },
    },
    {
      id: 'Adresa',
      name: 'Adresa',
      filter: { field: 'address', value: '', type: 'LIKE' },
    },
    {
      id: 'Telefon',
      name: 'Telefon',
      filter: { field: 'phoneNumber', value: '', type: 'LIKE' },
    },
    {
      id: 'Rola',
      name: 'Rola',
      filter: { field: 'role.roleName', value: '', type: 'CHILD_LIKE' },
    },
    ...(!isSuperAdmin ? [] : [{
      id: 'Kompanija',
      name: 'Kompanija',
      filter: {
        field: 'company.companyName',
        value: '',
        type: 'CHILD_LIKE',
      },
    }]),
    { id: 'status', name: 'status' },
    { id: 'Aktivacija / Deaktivacija', name: 'Aktivacija / Deaktivacija' },
    { id: 'Izmena', name: 'Izmena' },
  ];

  return (
    <FilterableTable
      tableStyle="table-container-with-row-below"
      columns={columns}
      action={findAllUsersPageble}
      rows={userListRow}
      totalElements={totalElements}
      filterPosition
    />
  );
};

export default UserTable;